/**
 * This class utilized by Modals.Alerts service.
 */
import ModalSafe from "./safe.model";

export default class ModalAlert extends ModalSafe {

}